import {ProductList} from "@connox/typescript-library";
import window from "../../../lib/WindowExtended";
import {ProductListState} from "../ProductListProvider";
import {isPercentDiscountSetUnderMin} from "./percentDiscountHelper";

export const updateProductListRequestParams = (state: ProductListState, keyToDelete?: string): void => {
  state.instance?.filter.applyFilterValue(state.filters);

  const hasLimitQuery = state.offset + state.limit > ProductList.PRODUCT_LIST_DEFAULT_LIMIT;
  const searchParams = new URLSearchParams(location.search);

  const filtersParams = new URLSearchParams(state.instance?.filter.requestParams);
  const filterItems = state.instance?.filter.filterItems;
  if (keyToDelete) {
    searchParams.delete(keyToDelete);
  }

  const percentDiscountMinValue = state.instance ? isPercentDiscountSetUnderMin(state.instance, state.filters) : false;
  if (percentDiscountMinValue) {
    filtersParams.set("percentageDiscount", `${percentDiscountMinValue}-`);
  }
  filterItems?.forEach((value, key) => {
    const keyValue = filtersParams.get(key);
    // Default filter should not be shown in the url. Default filters are set
    // in the `ProductListProvider.handleResponse()` before the dispatches

    if (keyValue && key !== state.defaultFilter?.split("=")[0]) {
      searchParams.set(key, keyValue);
    } else {
      searchParams.delete(key);
    }
  });

  if (hasLimitQuery) {
    searchParams.set("limit", String(state.offset + state.limit));
  } else {
    searchParams.delete("limit");
  }

  if (state.order && state.orderBy) {
    searchParams.set("order", `${state.orderBy}-${state.order}`);
  } else {
    searchParams.delete("order");
  }

  const url =
    window.location.origin +
    window.location.pathname +
    (searchParams.toString().length ? "?" + searchParams.toString() : "");

  window.history.replaceState(window.history.state, "Push with new Filter", url);
};
